import React, { useEffect, useState } from 'react'
import {NavbarContainer, LinkContainer, NavLinkContainer} from "./navbarStyles"
import { IoIosLogOut } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/user/userSlice';
import Modal from '../modal/Modal';
import { registrarEvento } from '../../registro/registro';
//import { jwtDecode } from 'jwt-decode';


const Navbar = () => {

  const currentUser = useSelector((state) => state.user.currentUser)
  const dispatch = useDispatch();

  const navigate = useNavigate();

  // Confirmación de salida al usar el botón "atrás" del navegador.
  const [showExitModal, setShowExitModal] = useState(false);
  // Confirmación de cierre de sesión desde el botón "Salir" del navbar.
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // Sesión válida = hay usuario Y el token todavía no expiró.
  const isSessionValid =
    currentUser?.expiresAt &&
    Date.now() < new Date(currentUser.expiresAt).getTime();

  // Si quedó un currentUser con token vencido (típico al recargar la app
  // con localStorage rehidratado), limpiamos el estado y volvemos a login.
  useEffect(() => {
    if (currentUser && !isSessionValid) {
      registrarEvento("web.sesion-vencida", "Sesión vencida al abrir la web");
      dispatch(logout());
      navigate("/");
    }
  }, [currentUser, isSessionValid, dispatch, navigate]);

  //Método para detectar el irAtrás del navegador: muestra el modal de salida.
  useEffect(() => {
    const handlePopState = () => setShowExitModal(true);
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  // Confirmar: sale del formulario al dashboard, manteniendo la sesión.
  const handleConfirmExit = () => {
    registrarEvento("formulario.salida", "Salió con el botón atrás del navegador");
    setShowExitModal(false);
    navigate("/dashboard");
  };

  // Cancelar: permanece en el formulario (igual que antes con confirm=false).
  const handleCancelExit = () => {
    setShowExitModal(false);
    navigate("/formulario");
  };

  // Confirmar cierre de sesión desde el botón "Salir".
  const handleConfirmLogout = () => {
    // Antes del logout: el registro toma las credenciales de la sesión actual.
    registrarEvento("web.logout", "Cerró sesión");
    setShowLogoutModal(false);
    dispatch(logout());
    navigate("/");
  };

  return (
    <>
     <Modal
       isOpen={showExitModal}
       onClose={handleCancelExit}
       onConfirm={handleConfirmExit}
       confirmText="Salir"
       cancelText="Cancelar"
     >
       <p>¿Desea salir del formulario?</p>
     </Modal>

     <Modal
       isOpen={showLogoutModal}
       onClose={() => setShowLogoutModal(false)}
       onConfirm={handleConfirmLogout}
       confirmText="Cerrar sesión"
       cancelText="Cancelar"
     >
       <p>¿Está seguro que quiere salir?</p>
     </Modal>

     <NavbarContainer>
        <h2>Gestión de Ventas</h2>
        {
          isSessionValid ? (  <LinkContainer>
            <span>Usuario: <strong>{currentUser?.usuario}</strong></span>
            {/* <span>Nivel: <strong>{currentUser?.data.level}</strong></span> */}
            {/* <NavLinkContainer onClick={()=>{ dispatch(navigate("/estado-cliente"))}}>
                Ver Cliente
            </NavLinkContainer> */}
            <NavLinkContainer onClick={() => setShowLogoutModal(true)}>
                Salir <IoIosLogOut style={{ fontSize: "2rem" }} />
            </NavLinkContainer>
        </LinkContainer>) : null
        }

     </NavbarContainer>
    </>
  )
}

export default Navbar